import { LoginComponent } from "../app/components/login/login.component";

export const environment = {
  production: false,
  language: "sl",  
  wgProfileHost: "https://po4-evozila-api.borzen.si",
 wgPlatformHost: "https://po4-evozila-platform.borzen.si",
 //wgProfileHost: "http://localhost:5000",
  //wgPlatformHost: "http://localhost:4300",

  loginComponent: LoginComponent,
  projIcon: "/assets/project-custom/images/borzen_logo_new.png",
  sidebarIcon: "/assets/project-custom/images/borzen_logo_new.png",
  projectCode: "BORZEN_EV",
  projectName: "",
  locale: 'sl-SI',
  useRouteAndMasterpageCache: true,
  ADLoginEnabled: false,
  dateFormat: 'DD.MM.YYYY',
  navigateAwayPopupEnabled: true,
  useEtag: true,
  newRegistrationLinkDocument: "",
  maxChunkNumber: 40,
  maxFileSizeInMb: 10,
  maxRecordNumberPerPageListing: 30,
  cacheEnabled: false,
  version: '1.1.0',
  showOnlyUserInHeader: true,
  //googleClientId: "866614170101-hp152kqqaidct6hfaeapdq1ntjm614b2.apps.googleusercontent.com", // fizince osebe evozila
  //googleClientId: "866614170101-oab513592ouvbu2q7tlplocnok6mif2c.apps.googleusercontent.com", // pravne osebe evozila
  //googleClientId: "344277045222-1p1hhb7cfelg4au0dbc4vjgap4cdlfj5.apps.googleusercontent.com", // sp evozila
  //googleClientId: "344277045222-us7deb7r9v9fn6s51sfa6nvosmab46ua.apps.googleusercontent.com", // fo3
  //googleClientId: "344277045222-8dmqfag461tddrsc43te7iv45odqp5nb.apps.googleusercontent.com", // po2  
    googleClientId: "344277045222-54j6f5s2r8puv983cslbj8h4qpi2n4rv.apps.googleusercontent.com", // po4
  useOldSearchViewFeature: false,
  usernameAlwaysToLower: true, // need this shit for EVOZILA1
  useInlineSearch: false,
  maxFileSizeInMbInMessenger: 5,
  projectSidebarName: "",
  theme: 'light'
};

